import { supabase } from "@/integrations/supabase/client";

/**
 * Resolve the post-login landing route by data, not just role.
 * - Admins/super_admins → /admin
 * - Agents → /agent
 * - Clients with a `clients` row → /client
 * - Clients with only Library purchases → /store/library
 * - Otherwise (brand-new account) → /store?welcome=1
 */
export async function resolveLandingRoute(userId: string): Promise<string> {
  const { data: roleRows } = await supabase
    .from("user_roles")
    .select("role")
    .eq("user_id", userId);
  const roles = (roleRows ?? []).map((r) => r.role as string);

  if (roles.includes("admin") || roles.includes("super_admin")) return "/admin";
  if (roles.includes("agent")) return "/agent";
  if (roles.includes("staff")) return "/staff";

  // Client (or no role at all) — route by data.
  const { data: clientRow } = await supabase
    .from("clients")
    .select("id")
    .eq("user_id", userId)
    .maybeSingle();
  if (clientRow) return "/client";

  const { data: libRow } = await supabase
    .from("user_library")
    .select("id")
    .eq("user_id", userId)
    .limit(1)
    .maybeSingle();
  if (libRow) return "/store/library";

  return "/store?welcome=1";
}